import React, { useEffect, useRef, useState } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Button,
  Avatar,
  CircularProgress,
} from "@mui/material";
import DoneImage from "../Components/assets/Images/congratsdoneimage.svg";
import ErrorImage from "../Components/assets/Images/errorImage.svg";
import { useLocation } from "react-router-dom";
import routesData from "../shared/routes.json";

import {
  CompleteAadhaarAPICall,
  digiLockerAuthenticationAPICall,
} from "../shared/APICalls";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Redirect.module.scss";
import { REDIRECTURL } from "../shared/constants";
import HeaderComp from "../Components/HeaderComp/HeaderComp";

export default function SuccessPage() {
  const [countDown, setCountDown] = useState(3);
  const [loading, setloading] = useState(true);
  const [apifailed, setapifailed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [link, setLink] = useState("");
  const countdownIntervalRef = useRef<ReturnType<typeof setInterval> | null>(
    null,
  );
  const redirectTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const navigationData = routesData;
  const pathName = useLocation().search;
  const dispatch = useDispatch();

  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());
  const setu_id = params.code;
  const state = params.state;

  // const shareCode = params.shareCode;
  console.log("params", params);
  //  console.log(pathName)
  sessionStorage.setItem("access-token", state);

  useEffect(() => {
    sendDetails();

    return () => {
      clearCountdownTimers();
    };
  }, []);

  function clearCountdownTimers() {
    if (countdownIntervalRef.current) {
      clearInterval(countdownIntervalRef.current);
      countdownIntervalRef.current = null;
    }

    if (redirectTimeoutRef.current) {
      clearTimeout(redirectTimeoutRef.current);
      redirectTimeoutRef.current = null;
    }
  }

  function startRedirectCountdown(redirectUrl?: string) {
    clearCountdownTimers();
    setCountDown(3);

    countdownIntervalRef.current = setInterval(() => {
      setCountDown((prevCountDown) => {
        if (prevCountDown <= 1) {
          if (countdownIntervalRef.current) {
            clearInterval(countdownIntervalRef.current);
            countdownIntervalRef.current = null;
          }

          return 0;
        }

        return prevCountDown - 1;
      });
    }, 1000);

    redirectTimeoutRef.current = setTimeout(() => {
      if (redirectUrl) {
        window.location.href = redirectUrl;
      }
    }, 3000);
  }

  function sendDetails() {
    let obj: any = {
      code: setu_id,
    };
    setloading(true);
    digiLockerAuthenticationAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        CompleteAadhaarStage();
      })
      .catch((error: any) => {
        clearCountdownTimers();
        setloading(false);

        setapifailed(true);
        setErrorMessage(error.response.data.message);
        setLink(error.response.data.link);
        // setTimeout(() => {
        //   window.location.href = `${REDIRECTURL}aadhaar`;
        // }, 5000);
      });
  }

  const CompleteAadhaarStage = () => {
    CompleteAadhaarAPICall()
      .then((response: any) => {
        setloading(false);
        const nextStage = response.data.data.next_stage;
        const redirectUrl =
          nextStage && navigationData.hasOwnProperty(nextStage)
            ? navigationData[nextStage]
            : undefined;

        startRedirectCountdown(redirectUrl);
      })
      .catch((error: any) => {
        clearCountdownTimers();
        setloading(false);
      });
  };

  return (
    <>
      <HeaderComp />
      <div className={styles.mainWrapperTop}>
        <div className={styles.wrapper}>
          <div className={styles.step}>
            {loading ? (
              <CircularProgress style={{ width: "80px", height: "80px" }} />
            ) : (
              <img src={apifailed ? ErrorImage : DoneImage} />
            )}
          </div>
          <div className={styles.leftContainer}>
            <div className={styles.headerSection}>
              <p className={styles.signup}>
                {" "}
                {loading
                  ? "Inprogress..."
                  : apifailed
                    ? errorMessage || "Failed to obtained your documents."
                    : "We have obtained your documents"}{" "}
              </p>

              <div className={styles.textdiv}>
                <p className={styles.instructiontext}>
                  {loading
                    ? "Please wait..., we are fetching your Documents. Please don't Close the Window."
                    : apifailed
                      ? ""
                      : `You will be redirected in ${countDown} seconds.`}
                </p>
              </div>

              {apifailed && (
                <div
                  className={styles.textdiv}
                  style={{ color: "var(--ds-info)" }}
                  onClick={() => {
                    window.open(link, "_blank");
                  }}
                >
                  {link}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
